<template>
  <b-modal
    ref="linkModal"
    id="linkModal"
    centered
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    :title="title"
    @hidden="clearModal"
    @close="cancel"
  >
    <b-container>
        <input type="hidden" v-model="url.type">
        <div class="row justify-content-between">
          <div class="col-12 form-group">
            <label for="url" class="subtext">Nome:</label>
            <input
              type="text"
              id="url"
              class="form-control"
              v-model="url.route_name"
              required
            />
          </div>
          <div class="col-12 form-group">
            <label class="col-12 p-0 subtext">Link para:</label>
            <select v-model="url.typeRoute" class="form-control col-12 p-0 mt-3">
              <option 
                value="route"
                :selected="url.typeRoute == 'route' ? true : false"
              >Url</option>
              <option 
                value="whats"
                :selected="url.typeRoute == 'whats' ? true : false"
              >Whatsapp</option>
            </select>
            <div v-if="url.typeRoute == 'route'">
              <input
                type="text"
                id="urlPath"
                class="form-control col-12 mt-3"
                v-model="url.route_path"
                placeholder="Endereço (url)"
                required
              />
            </div>
            
            <div v-if="url.typeRoute == 'whats'">
              <div class="row text-left mb-3 mt-3">
                  <div class="col-4 mb-3">
                    <span class="subtext">
                      <small>DDI</small>
                    </span>
                    <DDISelect :cId="newIdd" @getCountry="getCountry($event)"/>
                  </div>
                  <div class="col-8 mb-3">
                    <span class="subtext">
                      <small>Telefone (DDD + Número)</small>
                    </span>
                    <the-mask
                      v-if="newIdd == 30"
                      type="tel"
                      id="phone"
                      class="form-control hide-placeholder"
                      :mask="['(##)####-####', '(##)#####-####']"
                      placeholder="DDD + número"
                      v-model="url.phone"
                      @blur.native="verifyNumber"
                    />
                    <the-mask
                      v-else
                      :mask="'############'"
                      type="tel"
                      id="phone"
                      class="form-control hide-placeholder"
                      placeholder="DDD + número"
                      v-model="url.phone"
                    />
                    <p v-if="errorAlert" class="error_alert">
                      <small>Número de telefone inválido.</small>
                    </p>
                  </div>
                </div>
            </div>
            
          </div>
          <div class="col-12 form-group">
            <label for="targetBlank" class="subtext">Abrir em nova aba</label>
            <input
              type="checkbox"
              id="targetBlank"
              class=""
              v-model="url.target_blank"
            />
          </div>

          <div class="col-auto align-self-center">
            <span
              class="pointer py-2"
              @click="cancel()"
              >Cancelar</span
            >
          </div>
          <div class="col-auto">
            <button
              v-if="title == 'Editar Link'"
              @click="editLink()"
              class="btn btn-primario py-2"
              :disabled="saving ? true : false"
            >
              Salvar
            </button>
            <button
              v-else
              @click="addLink()"
              class="btn btn-primario py-2"
              :disabled="saving ? true : false"
            >
              Salvar
            </button>
          </div>
        </div>
    </b-container>
  </b-modal>
</template>

<script>
import DDISelect from "@/components/Country";
import apiMixins from "@/mixins/apiMixins";

export default {
  name: "ModalLinkBuilding",
  data() {
    return {
      newIdd: "",
      errorAlert: false,
      saving: false,
    }
  },
  mixins: [apiMixins],
  components:{
    DDISelect
  },
  props: {
    title: {
      type: String,
      required: true
    },
    url: {
      type: Object,
      required: true,
    },
    linkModal:{
      type: Boolean,
      default: false
    }
  },
  created(){
		this.newIdd = this.$store.state.application.default_idd ?? 30;
  },
  watch:{
    linkModal(){
      if(this.linkModal){
        this.$refs.linkModal.show();
      }
      else{
        this.$refs.linkModal.hide()
      }
      this.verifyLink()
    }
  },
  methods:{
    cancel(){
      this.$emit('onClose',false)
      this.$emit('clearModal')
    },
    verifyLink(){
      if(this.url.route_path.indexOf('https://wa.me') == 0){
       this.url.typeRoute = 'whats'
       this.url.phone = this.url.route_path.replace('https://wa.me/55','')
      }
      else{
        this.url.typeRoute = 'route'
      }
    },
    clearModal() {
      this.newAdvertise = {
        title: "",
        advertisementType: "banner",
        advertisementPosition: "footer",
        content: "",
        ref: "",
        image: "",
      };
      this.saving = false;
      this.$emit('savingModal',this.saving)
    },
    async addLink(){
      if (!this.validateLink()) {
        return;
      }
      const url = `/site/${this.$session.get("siteId")}/linkBuilding/create`;
      
      this.saving = true;
      this.$emit('savingModal',this.saving)
      const linkUrl = await this.requestApiData(
        url,
        "post",
        this.url
      );
      if(linkUrl.status == true){
        this.resetVariable('url');
        this.$emit('linksBuilding',linkUrl.message.data)
        this.saving = false;
        this.$emit('savingModal',this.saving)
        this.$emit('onClose',false)
        this.$emit('clearModal')
      }
      else{
        alert('erro ao cadastrar url');
        this.saving = false;
        this.$emit('savingModal',this.saving)
        this.$emit('onClose',false)
      }
    },
    async editLink(){
      if (!this.validateLink()) {
        return;
      }

      const url = `/site/${this.$session.get("siteId")}/linkBuilding/${this.url.id}/update`;
      
      this.saving = true;
      this.$emit('savingModal',this.saving)
      const linkUrl = await this.requestApiData(
        url,
        "post",
        this.url
      );
      if(linkUrl.status == true){
        this.resetVariable('url');
        this.saving = false;
        this.$emit('savingModal',this.saving)
        this.$emit('onClose',false)
        this.$emit('clearModal')
      }
      else{
        alert('erro ao cadastrar url');
        this.saving = false;
        this.$emit('savingModal',this.saving)
        this.$emit('onClose',false)
      }
    },
    validateLink() {
      if (!this.url.route_name) {
        this.focusInvalidInput('url', 'Erro ao salvar o link: insira um nome para o link!')
        return false;
      }
      
      if (this.url.typeRoute == 'route' && !this.url.route_path) {
        this.focusInvalidInput('urlPath', 'Erro ao salvar o link: link vazio!')
        return false;
      }

      if (this.url.typeRoute == 'whats') {
        if (!this.url.ddi) {
          this.focusInvalidInput('idd-selector', 'Erro ao salvar o link: informe o DDI!');
          return false;
        }
  
        if (!this.url.phone) {
          this.focusInvalidInput('phone', 'Erro ao salvar o link: telefone vazio!');
          return false;
        }
      }

      return true;
    },
    focusInvalidInput(input, message) {
        alert(message);
        document.getElementById(input).focus();
    },
    getCountry(event) {
      this.newIdd = event;
      this.url.ddi = event;
    },
    verifyNumber() {
      const minMobileBrazilNumberLength = 10;
      if (this.url.phone.length >= minMobileBrazilNumberLength) {
        this.errorAlert = false;
      } else {
        this.errorAlert = true;
      }
    },
    resetVariable(variable){
      var reset = this.$options.data.call(this);
      this.$data[variable] = reset[variable];
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/organisms/ModalLinkBuilding.vue